import { Text } from '@mxenabled/mxui'

import { GridCellParams } from '@mui/x-data-grid'

const TitleRowCell = (params: GridCellParams) => (
  <Text variant="body2" sx={{ p: 16 }}>
    {params.row.title}
  </Text>
)

export default TitleRowCell
